import {
  ApiGetUserResult,
  IGetUserDetailResponse,
  TUserDetail,
} from '~/src/repositories/User/models/User'

export const convertUserDetail = (data: ApiGetUserResult): IGetUserDetailResponse => ({
  user: {
    companyName: data?.user?.companyName ?? '',
    name: data?.user?.name ?? '',
    email: data?.user?.email ?? '',
    tel: data?.user?.tel ?? '',
    fax: data?.user?.fax ?? '',
    mobile: data?.user?.mobile ?? '',
    countryId: data?.user?.country?.id!,
    country: data?.user?.country?.name ?? '',
    city: data?.user?.city ?? '',
    address1: data?.user?.address1 ?? '',
    address2: data?.user?.address2 ?? '',
    status: data?.user?.status ?? '',
    isSigned: Number(data?.user?.isSigned),
    canSearchGenuinePart: Number(data?.user?.canSearchGenuinePart),
    token: data?.user?.token ?? '',
    loadingPortId: data?.user?.loadingPort?.id ?? '',
    loadingPort: data?.user?.loadingPort?.name ?? '',
  },
  destinations: data?.destinations?.map(mapItem) || [],
})

const mapItem = (data: any): TUserDetail => ({
  id: data?.id,
  consignee: {
    companyName: data?.consignee?.companyName ?? '',
    name: data?.consignee?.name ?? '',
    email: data?.consignee?.email ?? '',
    tel: data?.consignee?.tel ?? '',
    fax: data?.consignee?.fax ?? '',
    crnNo: data?.consignee?.crnNo ?? '',
    countryId: data?.consignee?.country?.id,
    portOfDischargeId: data?.consignee?.portOfDischarge?.id,
    finalDestinationId: data?.consignee?.finalDestination?.id,
    address1: data?.consignee?.address1 ?? '',
    address2: data?.consignee?.address2 ?? '',
  },
  notifyParty: {
    companyName: data?.notifyParty?.companyName ?? '',
    name: data?.notifyParty?.name ?? '',
    email: data?.notifyParty?.email ?? '',
    tel: data?.notifyParty?.tel ?? '',
    fax: data?.notifyParty?.fax ?? '',
    crnNo: data?.notifyParty?.crnNo ?? '',
    countryId: data?.notifyParty?.country?.id,
    address1: data?.notifyParty?.address1 ?? '',
    address2: data?.notifyParty?.address2 ?? '',
  },
})
